import {runOrQueueToolCall} from "./ide/ideToolCallHandler.ts";

export const executeAppToolCall = async (finishedToolCall: any, environmentObjRef: any, llmRequestRefs: any, dynamicStateObjRef: any, settingsObjRef: any) => {
    switch (finishedToolCall.name) {
        case 'openFile':
        case 'editFile':
        case 'createFile':
        case 'deleteFile':
        case 'moveFile':
        case 'runTerminalCommand':
        case 'searchCodebase':
        case 'grepCodebase':
        case 'viewDirectory':
        case 'reviewChanges':
            await runOrQueueToolCall(llmRequestRefs, "newCall", environmentObjRef, finishedToolCall, dynamicStateObjRef, settingsObjRef);
            break;
    }
}